export const NOTE_TYPES = {
  PROGRESS_NOTE: 'progress_note',
  VITALS: 'vitals',
  HANDOVER: 'handover',
  ADMISSION: 'admission',
  DISCHARGE: 'discharge',
  MEDICATION_ADMIN: 'medication_admin',
  FLUID_BALANCE: 'fluid_balance',
  CARE_PLAN: 'care_plan',
};

export const NOTE_TYPE_LABELS = {
  progress_note: 'Progress Note',
  vitals: 'Vitals',
  handover: 'Handover / Shift Report',
  admission: 'Admission',
  discharge: 'Discharge',
  medication_admin: 'Medication Admin',
  fluid_balance: 'Fluid Balance',
  care_plan: 'Care Plan',
};

export const NOTE_TYPE_BADGE_COLORS = {
  progress_note: 'bg-blue-700 text-white',
  vitals: 'bg-emerald-600 text-white',
  handover: 'bg-amber-500 text-gray-950',
  shift_handover: 'bg-amber-500 text-gray-950',
  admission: 'bg-cyan-600 text-white',
  discharge: 'bg-rose-600 text-white',
  medication_admin: 'bg-violet-600 text-white',
  fluid_balance: 'bg-teal-600 text-white',
  care_plan: 'bg-rose-600 text-white',
};

export const MANUAL_NOTE_TYPES = [];

export const APP_TABS = {
  PATIENTS: 'patients',
  NOTES: 'notes',
  VITALS: 'vitals',
  MEDICATIONS: 'medications',
  REPORTS: 'reports',
};

export const SCREENS = {
  PRE_RECORDING: 1,
  RECORDING: 2,
  GENERATING: 3,
  NOTE_REVIEW: 4,
};

export function createEmptyAdmissionNote() {
  return {
    note_type: 'admission',
    chief_complaint: '',
    hpi: '',
    medical_history: [],
    surgical_history: '',
    allergies: [],
    home_medications: [],
    family_history: '',
    social_history: '',
    review_of_systems: '',
    patient: { name: null, room: null, age: null, sex: null, nationality: null },
  };
}

export function createEmptyDischargeNote() {
  return {
    note_type: 'discharge',
    narrative: '',
    condition_at_discharge: '',
    discharge_mode: '',
    accompanied_by: '',
    education: [],
    discharge_medications: [],
    follow_up: { physician: '', timeframe: '', location: '' },
    understanding_patient: false,
    understanding_family: false,
    special_instructions: '',
    patient: { name: null, room: null, age: null, sex: null },
  };
}

export function createEmptyMarNote() {
  return {
    note_type: 'medication_admin',
    medications_administered: [],
    medications: [],
    unverified_medications: [],
    nurse_observations: null,
    negations_detected: [],
    flags: [],
    patient: { name: null, room: null, age: null, sex: null, details_source: 'transcript' },
  };
}

export function createEmptyFluidBalanceNote() {
  return {
    note_type: 'fluid_balance',
    fluid_inputs: [],
    fluid_outputs: [],
    flags: [],
    patient: { name: null, room: null, age: null, sex: null, details_source: 'transcript' },
  };
}
